/* DARKGROUND DESIGN SYSTEM · home behaviour
   [data-dg-slides]: full-screen slideshow. Auto-advance, pause on hover, swipe on touch screens, arrow keys,
   only the visible slide's video plays. Optional progress tabs. No autoplay with reduced motion.
   [data-dg-count]: numbers count up once when they scroll into view (final value is already in the HTML).
   [data-dg-tl]: the vertical line of the figures section fills while you scroll through it.
   [data-dg-hidx]: store index, the collection image follows the cursor while hovering a row (desktop).
   [data-dg-hcar]: product carousel arrows and progress bar.
   [data-dg-sc]: latest SoundCloud releases (one track per release) drawn in the site's design, with the
   buy link set on SoundCloud (Beatport, Bandcamp...). Played through a hidden SoundCloud player that is
   only loaded when the section gets close to the screen. Cards come in left to right once on screen.
   Each card's progress bar can be clicked, tapped or dragged to jump to any point of the track (a track that is
   not playing starts directly from that point).
   Icons are inline SVG (never arrow characters, which iOS turns into emoji).
*/
(function () {
  'use strict';
  if (window.__dgHomeLoaded) return;
  window.__dgHomeLoaded = true;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- SLIDESHOW ---------- */
  function initSlides(root) {
    if (root.dataset.dgInit) return;
    root.dataset.dgInit = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
    if (!slides.length) return;
    var dur = parseInt(root.getAttribute('data-duration') || '10000', 10);
    var current = 0;
    var timer = null;
    var startedAt = 0;
    var remaining = dur;
    var paused = false;
    var visible = true;
    root.style.setProperty('--dg-dur', dur + 'ms');

    function playVideo(k) {
      slides.forEach(function (s, j) {
        var v = s.querySelector('video');
        if (!v) return;
        if (j === k) {
          v.muted = true;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }
    function restartBar() {
      tabs.forEach(function (t) { t.classList.remove('is-run'); });
      var t = tabs[current];
      if (!t) return;
      void t.offsetWidth;
      t.classList.add('is-run');
    }
    function schedule(ms) {
      clearTimeout(timer);
      if (slides.length < 2 || reduced) return;
      startedAt = Date.now();
      remaining = ms;
      timer = setTimeout(function () { go(current + 1); }, ms);
    }
    function go(n) {
      var next = (n + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (tabs[current]) { tabs[current].classList.remove('is-active'); tabs[current].setAttribute('aria-selected', 'false'); }
      current = next;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      if (tabs[current]) { tabs[current].classList.add('is-active'); tabs[current].setAttribute('aria-selected', 'true'); }
      root.setAttribute('data-current', current);
      playVideo(current);
      if (!reduced) restartBar();
      root.classList.remove('is-paused');
      paused = false;
      schedule(dur);
    }
    function pause() {
      if (paused || reduced || slides.length < 2) return;
      paused = true;
      clearTimeout(timer);
      remaining = Math.max(400, remaining - (Date.now() - startedAt));
      root.classList.add('is-paused');
    }
    function resume() {
      if (!paused || !visible) return;
      paused = false;
      root.classList.remove('is-paused');
      schedule(remaining);
    }

    tabs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = root.querySelector('[data-prev]');
    var nextBtn = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(current + 1); });
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(current + 1);
      if (e.key === 'ArrowLeft') go(current - 1);
    });
    var x0 = null;
    var y0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(current + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible = en.isIntersecting;
          var v = slides[current].querySelector('video');
          if (!visible) { pause(); if (v) v.pause(); }
          else { if (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } resume(); }
        });
      }, { threshold: 0.2 }).observe(root);
    }
    go(0);
  }

  /* ---------- COUNT UP ---------- */
  function countUp(el) {
    if (el.dataset.dgCounted) return;
    el.dataset.dgCounted = '1';
    var to = parseFloat(el.getAttribute('data-to')) || 0;
    var dec = parseInt(el.getAttribute('data-decimals') || '0', 10);
    var pre = el.getAttribute('data-prefix') || '';
    var suf = el.getAttribute('data-suffix') || '';
    if (reduced) return;
    var t0 = null;
    var d = 2200;
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / d);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + (to * e).toFixed(dec) + suf;
      if (p < 1) requestAnimationFrame(frame);
      else el.textContent = pre + to.toFixed(dec) + suf;
    }
    el.textContent = pre + (0).toFixed(dec) + suf;
    requestAnimationFrame(frame);
  }
  function initCounts(root) {
    var els = Array.prototype.slice.call((root || document).querySelectorAll('[data-dg-count]'));
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var row = en.target.closest('li');
        if (row) row.classList.add('is-in');
        var wrap = en.target.closest('[data-dg-count-root]');
        if (wrap) wrap.classList.add('is-in');
        countUp(en.target);
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { if (!el.dataset.dgCounted) io.observe(el); });
  }

  /* ---------- TIMELINE LINE ---------- */
  function initTimeline(root) {
    if (root.dataset.dgTlInit) return;
    root.dataset.dgTlInit = '1';
    var list = root.querySelector('.dg-tl');
    if (!list) return;
    var ticking = false;
    function update() {
      ticking = false;
      var r = list.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var p = (vh * 0.62 - r.top) / Math.max(1, r.height);
      p = Math.max(0, Math.min(1, p));
      list.style.setProperty('--dg-tl-p', (p * 100).toFixed(1) + '%');
    }
    if (reduced) { list.style.setProperty('--dg-tl-p', '100%'); return; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- STORE INDEX (floating image) ---------- */
  function initIndex(root) {
    if (root.dataset.dgInit) return;
    root.dataset.dgInit = '1';
    var list = root.querySelector('.dg-hidx__list');
    var float = root.querySelector('.dg-hidx__float');
    if (!list || !float) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    var imgs = Array.prototype.slice.call(float.querySelectorAll('[data-k]'));
    var x = 0, y = 0, tx = 0, ty = 0, raf = null, on = false, first = true;
    function loop() {
      var k = reduced ? 1 : 0.16;
      x += (tx - x) * k;
      y += (ty - y) * k;
      float.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
      if (on || Math.abs(tx - x) + Math.abs(ty - y) > 0.5) raf = requestAnimationFrame(loop);
      else raf = null;
    }
    list.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (first) { x = tx; y = ty; first = false; }
      if (!raf) raf = requestAnimationFrame(loop);
    });
    list.querySelectorAll('.dg-hidx__row').forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        var k = row.getAttribute('data-k');
        imgs.forEach(function (im) { im.classList.toggle('is-on', im.getAttribute('data-k') === k); });
        float.classList.add('is-on');
        list.classList.add('is-hovering');
        on = true;
        if (!raf) raf = requestAnimationFrame(loop);
      });
    });
    list.addEventListener('mouseleave', function () {
      float.classList.remove('is-on');
      list.classList.remove('is-hovering');
      on = false;
      first = true;
    });
  }

  /* ---------- PRODUCT CAROUSEL ---------- */
  function initCarousel(root) {
    if (root.dataset.dgCarInit) return;
    root.dataset.dgCarInit = '1';
    var track = root.querySelector('[data-car-track]');
    if (!track) return;
    var prev = root.querySelector('[data-car-prev]');
    var next = root.querySelector('[data-car-next]');
    var bar = root.querySelector('[data-car-bar]');
    function step() {
      var s = track.querySelector('.dg-hprod__slide');
      return s ? s.getBoundingClientRect().width + 22 : 320;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      if (bar) {
        var w = Math.max(12, Math.min(100, track.clientWidth / track.scrollWidth * 100));
        bar.style.width = w + '%';
        bar.style.left = (p * (100 - w)).toFixed(2) + '%';
      }
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- SOUNDCLOUD RELEASES ---------- */
  var scQueue = null;
  function loadScApi(cb) {
    if (window.SC && window.SC.Widget) { cb(); return; }
    if (scQueue === null) {
      scQueue = [cb];
      var s = document.createElement('script');
      s.src = 'https://w.soundcloud.com/player/api.js';
      s.async = true;
      s.onload = function () { var q = scQueue; scQueue = 'done'; q.forEach(function (f) { f(); }); };
      s.onerror = function () { scQueue = 'failed'; };
      document.head.appendChild(s);
    } else if (scQueue === 'done') {
      cb();
    } else if (Array.isArray(scQueue)) {
      scQueue.push(cb);
    }
  }
  function esc(t) { return String(t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var PLAY = '<svg class="i-play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg><svg class="i-pause" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"/></svg>';
  var EXT = '<svg class="dg-ext" width="11" height="11" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 17 17 7M9 7h8v8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="square"/></svg>';
  function releaseKey(s) {
    if (s.purchase_url) return 'buy:' + s.purchase_url.split('?')[0].replace(/\/+$/, '');
    if (s.artwork_url) return 'art:' + s.artwork_url.replace(/-(large|t\d+x\d+|original)\./, '.');
    return 'id:' + s.id;
  }
  function buyInfo(s, artist, title, root) {
    var url = s.purchase_url || ('https://www.beatport.com/search?q=' + encodeURIComponent(artist + ' ' + title));
    var host = '';
    try { host = new URL(url).hostname; } catch (e) {}
    var label = root.getAttribute('data-buy-label') || 'Buy';
    if (/beatport/.test(host)) label = root.getAttribute('data-beatport-label') || 'Buy on Beatport';
    else if (/bandcamp/.test(host)) label = root.getAttribute('data-bandcamp-label') || 'Buy on Bandcamp';
    return { url: url, label: label };
  }
  function niceDate(s) {
    var raw = s.release_date || s.display_date || s.created_at;
    if (!raw) return { text: '', fresh: false };
    var d = new Date(raw);
    if (isNaN(d)) return { text: '', fresh: false };
    var days = (Date.now() - d.getTime()) / 864e5;
    return { text: d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }), fresh: days >= -1 && days <= 21 };
  }

  function initSC(root) {
    if (root.dataset.dgInit) return;
    root.dataset.dgInit = '1';
    var iframe = root.querySelector('[data-sc-widget]');
    var grid = root.querySelector('[data-sc-grid]');
    var count = parseInt(root.getAttribute('data-count') || '4', 10);
    var newLabel = root.getAttribute('data-new-label') || 'New';
    if (!iframe || !grid) return;
    var started = false;

    function revealWhenVisible() {
      if (reduced || !('IntersectionObserver' in window)) { root.classList.add('is-ready'); return; }
      var r = grid.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      if (r.top < vh * 0.85 && r.bottom > 0) { requestAnimationFrame(function () { root.classList.add('is-ready'); }); return; }
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { o.disconnect(); root.classList.add('is-ready'); } });
      }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
      o.observe(grid);
    }

    function start() {
      var done = false;
      var fallbackTimer = setTimeout(function () { if (!done) root.classList.add('is-fallback'); }, 15000);
      if (iframe.getAttribute('data-src') && !iframe.getAttribute('src')) iframe.setAttribute('src', iframe.getAttribute('data-src'));
      loadScApi(function () {
        var w = window.SC.Widget(iframe);
        var picks = [];
        var current = -1;
        var playing = false;
        var ticker = null;
        var pendingSeek = null;
        var scrubbing = -1;
        function cards() { return Array.prototype.slice.call(grid.querySelectorAll('[data-i]')); }
        function cardFor(idx) { return grid.querySelector('[data-i="' + idx + '"]'); }
        function mark() {
          cards().forEach(function (c) {
            var i = parseInt(c.getAttribute('data-i'), 10);
            c.classList.toggle('is-current', i === current);
            c.classList.toggle('is-playing', i === current && playing);
          });
        }
        function setFill(idx, pct) {
          var c = cardFor(idx);
          var b = c && c.querySelector('.dg-hrel__bar span');
          if (b) b.style.width = Math.max(0, Math.min(100, pct)).toFixed(1) + '%';
        }
        function tick() {
          if (scrubbing === current) return;
          w.getPosition(function (pos) {
            w.getDuration(function (dur) {
              if (dur && scrubbing !== current) setFill(current, (pos / dur) * 100);
            });
          });
        }
        function startTicker() { clearInterval(ticker); ticker = setInterval(tick, 500); }
        function stopTicker() { clearInterval(ticker); ticker = null; }
        function seekCard(i, ratio) {
          setFill(i, ratio * 100);
          if (i === current) {
            w.getDuration(function (d) {
              if (d) w.seekTo(ratio * d);
              if (!playing) w.play();
            });
          } else {
            if (current > -1) setFill(current, 0);
            current = i;
            pendingSeek = ratio;
            mark();
            w.skip(i);
          }
        }
        function bindBar(c, i) {
          var bar = c.querySelector('.dg-hrel__bar');
          if (!bar) return;
          bar.setAttribute('role', 'slider');
          bar.setAttribute('aria-label', 'Jump to a point of the track');
          bar.setAttribute('aria-valuemin', '0');
          bar.setAttribute('aria-valuemax', '100');
          function ratioAt(ev) {
            var r = bar.getBoundingClientRect();
            return Math.min(1, Math.max(0, (ev.clientX - r.left) / Math.max(1, r.width)));
          }
          bar.addEventListener('pointerdown', function (ev) {
            ev.preventDefault();
            scrubbing = i;
            try { bar.setPointerCapture(ev.pointerId); } catch (e) {}
            setFill(i, ratioAt(ev) * 100);
          });
          bar.addEventListener('pointermove', function (ev) {
            if (scrubbing === i) setFill(i, ratioAt(ev) * 100);
          });
          bar.addEventListener('pointerup', function (ev) {
            if (scrubbing !== i) return;
            scrubbing = -1;
            seekCard(i, ratioAt(ev));
          });
          bar.addEventListener('pointercancel', function () { scrubbing = -1; });
        }
        function render() {
          grid.innerHTML = picks.map(function (p) {
            var s = p.s;
            var art = (s.artwork_url || (s.user && s.user.avatar_url) || '').replace('-large.', '-t500x500.');
            var title = s.title || '';
            var artist = (s.user && s.user.username) || '';
            var cut = title.indexOf(' - ');
            if (cut > 0) { artist = title.slice(0, cut); title = title.slice(cut + 3); }
            var buy = buyInfo(s, artist, title, root);
            var date = niceDate(s);
            return '<article class="dg-hrel__card" data-i="' + p.i + '">' +
              '<button type="button" class="dg-hrel__art" aria-label="Play ' + esc(artist + ' - ' + title) + '">' +
                (art ? '<img src="' + esc(art) + '" alt="" loading="lazy">' : '') +
                (date.fresh ? '<span class="dg-hrel__new">' + esc(newLabel) + '</span>' : '') +
                '<span class="dg-hrel__play">' + PLAY + '</span>' +
              '</button>' +
              '<span class="dg-hrel__bar"><span></span></span>' +
              '<span class="dg-hrel__meta"><span class="dg-hrel__artist">' + esc(artist) + '</span>' + (date.text ? '<span class="dg-hrel__date">' + esc(date.text) + '</span>' : '') + '</span>' +
              '<a class="dg-hrel__title" href="' + esc(s.permalink_url || '#') + '" target="_blank" rel="noopener">' + esc(title) + '</a>' +
              '<a class="dg-hrel__buy" href="' + esc(buy.url) + '" target="_blank" rel="noopener">' + esc(buy.label) + EXT + '</a>' +
            '</article>';
          }).join('');
          cards().forEach(function (c, n) {
            c.style.setProperty('--dg-in', (n * 140) + 'ms');
            var i = parseInt(c.getAttribute('data-i'), 10);
            c.querySelector('.dg-hrel__art').addEventListener('click', function () {
              if (i === current) { if (playing) w.pause(); else w.play(); return; }
              if (current > -1) setFill(current, 0);
              current = i;
              pendingSeek = null;
              mark();
              w.skip(i);
            });
            bindBar(c, i);
          });
          revealWhenVisible();
        }
        w.bind(window.SC.Widget.Events.READY, function () {
          w.getSounds(function (list) {
            var seen = {};
            picks = [];
            (list || []).forEach(function (s, i) {
              if (!s || !s.title || picks.length >= count) return;
              var k = releaseKey(s);
              if (seen[k]) return;
              seen[k] = 1;
              picks.push({ s: s, i: i });
            });
            if (!picks.length) { root.classList.add('is-fallback'); return; }
            done = true;
            clearTimeout(fallbackTimer);
            root.classList.remove('is-fallback');
            render();
          });
        });
        w.bind(window.SC.Widget.Events.PLAY, function () {
          playing = true;
          w.getCurrentSoundIndex(function (i) { if (typeof i === 'number' && i >= 0) current = i; mark(); });
          if (pendingSeek !== null) {
            var r = pendingSeek;
            pendingSeek = null;
            w.getDuration(function (d) { if (d) w.seekTo(r * d); });
          }
          startTicker();
        });
        w.bind(window.SC.Widget.Events.PAUSE, function () { playing = false; mark(); stopTicker(); });
        w.bind(window.SC.Widget.Events.FINISH, function () { playing = false; mark(); stopTicker(); w.pause(); });
      });
    }
    function maybeStart() {
      if (started) return;
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      if (r.top < vh + 700 && r.bottom > -700) {
        started = true;
        window.removeEventListener('scroll', maybeStart);
        start();
      }
    }
    window.addEventListener('scroll', maybeStart, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); maybeStart(); } });
      }, { rootMargin: '700px 0px' });
      io.observe(root);
    }
    maybeStart();
  }

  function init(root) {
    var r = root || document;
    r.querySelectorAll('[data-dg-slides]').forEach(initSlides);
    r.querySelectorAll('[data-dg-sc]').forEach(initSC);
    r.querySelectorAll('[data-dg-tl]').forEach(initTimeline);
    r.querySelectorAll('[data-dg-hidx]').forEach(initIndex);
    r.querySelectorAll('[data-dg-hcar]').forEach(initCarousel);
    initCounts(r);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
